/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';


export const protective_equipment_other : {[key: string]: Array<[string, string]>} = {
};
